document.addEventListener(
  'Neos.NodeCreated',
  function (event) {
    const element = event.detail.element;
    const elementClasses = element.classList;

    switch (true) {
      case elementClasses.contains('Accordion'):
        accordionInit(element);
        break;
    }
  },
  false,
);

// init single Instance
const accordionInit = (element) => {
  const AccordionInstance = new Accordion(element, {
    isNeosBackend: element.dataset.isneosbackend,
  });
  element.querySelectorAll('[data-active]').forEach((item) => AccordionInstance.toggleItem(item));
};

// init every accordion instance on the DOM
const Accordions = document.querySelectorAll('.Accordion');
Accordions.forEach((accordion) => {
  accordionInit(accordion);
});

// accordion
function Accordion(el, options) {
  const defaultOptions = {
    selectorItem: '.AccordionItem', // selector of the accordion item
    selectorTrigger: '.AccordionItem-title', // selector for the clicked trigger element
    selectorContent: '.AccordionItem-content', // selector for content element
    classNameActive: 'AccordionItem--active', // class name for active items
    oneOpen: false, // only one item can be active on click
    isNeosBackend: false,
    openOnAdd: true,
  };

  options = { ...defaultOptions, ...options };

  //let _this = this;
  let accordionItems = [];

  this.init = () => {
    el.querySelectorAll(options.selectorItem).forEach((item) => {
      this.initItem(item);
    });

    // observe for new added items
    const observer = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type == 'childList' && mutation.addedNodes[0]) {
          this.initItem(mutation.addedNodes[0]);
          if (options.openOnAdd) this.itemClick(mutation.addedNodes[0]);
        }
      });
    });
    observer.observe(el, { childList: true });
  };

  this.initItem = (item) => {
    item.querySelector(options.selectorTrigger).addEventListener('click', () => this.itemClick(item));
    accordionItems.push(item);
  };

  this.itemClick = (clickedItem) => {
    // if oneOpen option is set, close all others
    if (options.oneOpen) {
      const itemsActive = el.querySelectorAll('.' + options.classNameActive);

      if (!clickedItem.classList.contains(options.classNameActive)) {
        this.toggleItem(clickedItem);
      }

      itemsActive.forEach((activeItem, index) => {
        this.toggleItem(activeItem);
      });
      return;
    }

    // toggle the clicked item if multible items can be open
    this.toggleItem(clickedItem);
  };

  this.toggleItem = (item) => {
    const content = item.querySelector(options.selectorContent);

    if (options.isNeosBackend) {
      // ToDo: evaluate a better solution for flexible content height in edit mode.
      content.style.maxHeight = content.style.maxHeight ? null : '100%';
      item.classList.toggle(options.classNameActive);
      return;
    }

    content.style.maxHeight = content.style.maxHeight ? null : content.scrollHeight + 'px';
    item.classList.toggle(options.classNameActive);
  };

  this.init();
}
